"use client";
import '@/i18n';

import Footer from "@/components/Footer";
import Header from "@/components/Header";
import ScrollToTop from "@/components/ScrollToTop";
import "../styles/index.css"; // This should import the CSS with local fonts
import { Providers } from "./providers";
import { usePathname } from "next/navigation";
import { GoogleAnalytics } from '@next/third-parties/google'
import Script from 'next/script';
import dynamic from 'next/dynamic';
import { ClientContent } from '@/components/Client/ClientContent';


// Import Analytics dynamically with no SSR to avoid hydration issues
const Analytics = dynamic(() => import('@/components/Common/Analytics'), { ssr: false });

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isDashboard = pathname ? pathname.startsWith("/dashboard") : false;

  return (
    <html suppressHydrationWarning lang="en">
      <head>
        {/* Traditional Google Analytics implementation as fallback */}
        <Script
          src="https://www.googletagmanager.com/gtag/js?id=G-0L55JXJFB6"
          strategy="afterInteractive"
        />
        <Script id="google-analytics" strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-0L55JXJFB6', {
              page_path: window.location.pathname,
              send_page_view: true
            });
          `}
        </Script>
      </head>
      <body className="bg-[#FCFCFC] dark:bg-black">
      <Providers>
        <ClientContent>
          {!isDashboard && <Header />}
          {children}
          {!isDashboard && <Footer />}
          <ScrollToTop />
        </ClientContent>
        <Analytics />
      </Providers>
      </body>
      {/* Next.js Third-party approach */}
      <GoogleAnalytics gaId="G-0L55JXJFB6" />
    </html>
  );
}
